// extracted by mini-css-extract-plugin
export default {"main":"Social_main__wvc-a","capsule-textfield":"Social_capsule-textfield__go1dl"};